import { API_VERSION } from '@/apis/constants';
import { Api } from '@/typings/api';
import { ApiMethod, ApiService, buildUrl } from '@/utils/api';
import Request from '@/utils/Request';

import {
  GetMakgeolliFactorsGreenhouseGasesParams,
  GetMakgeolliFactorsGreenhouseGasesRes,
  // [PLOP ANCHOR] dtoImport
} from './greenhouse-gases.dto';

const request = Request.getInstance().request;

export const getMakgeolliFactorsGreenhouseGasesUrl = () =>
  buildUrl({
    service: ApiService.MAKGEOLLI,
    version: API_VERSION[ApiService.MAKGEOLLI],
    path: `/factors/greenhouse_gases`,
  });
// [PLOP ANCHOR] apisUrl

export const getMakgeolliFactorsGreenhouseGases: Api<
  GetMakgeolliFactorsGreenhouseGasesParams,
  GetMakgeolliFactorsGreenhouseGasesRes
> = (payload) =>
  request({
    url: getMakgeolliFactorsGreenhouseGasesUrl(),
    method: ApiMethod.GET,
    params: payload.query,
  });

// [PLOP ANCHOR] apisDefinition
